import * as React from 'react';

import SearchBox from './SearchBox';

/* NOTE: requires user log in */
class SearchBoxVisual extends React.Component {
    public render() {
        return (
            <div style={{
                background: "#ffe216" ,
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start"
                }}>

                <div style={{width: "400px", padding: "20px", borderBottom: "2px solid #191705"}}>
                    <SearchBox onSearchTriggered={this.voidFn} />
                </div>
                
                <div style={{width: "600px", padding: "20px", borderBottom: "2px solid #191705"}}>
                    <SearchBox onSearchTriggered={this.voidFn} />
                </div>

                <div style={{width: "800px", padding: "20px" }}>
                    <SearchBox onSearchTriggered={this.voidFn} />
                </div>
            </div>
        );
    }

    public voidFn = () => {
        /* this is not empty */
    };
}

export default SearchBoxVisual;


// WEBPACK FOOTER //
// ./src/App/Blocks/SearchBox.visual.tsx